import { analytics } from "@moodys/federated";
import { LinkType } from "@moodys/federated/types/services/analytics";

export interface AnalyticsTagProps {
  category?: string;
  id?: string;
  linkType?: string;
  moduleName?: string;
  name?: string;
  siteSection?: string;
  type?: LinkType;
}

export const generateAnalyticsProp = ({
  type = analytics.LinkType.TEXT,
  siteSection = "",
  moduleName = "",
  linkType = "",
  id = "",
  name = "",
  category = "",
}: AnalyticsTagProps) => ({
  "data-analytics-link": analytics.createAnalyticsTag({
    category,
    type,
    siteSection,
    moduleName,
    linkType,
    id,
    name,
  }),
});

export const generateFooterAnalyticsProp = (
  props: Omit<AnalyticsTagProps, "category">
) => generateAnalyticsProp({ category: "Footer", ...props });

export const generateHeaderAnalyticsProp = (
  props: Omit<AnalyticsTagProps, "category">
) => generateAnalyticsProp({ category: "GlobalNav", ...props });
